import React, { useState, useEffect } from "react";
import axios from "axios";

// Components
import Preloader from "../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";

//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";
import { NavLink } from "react-router-dom";
// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Grid,
	Select,
	InputLabel,
	Input,
	// MenuItem,
	Modal,
	Backdrop,
	Fade,
	FormHelperText,
	NativeSelect,
	Button,
} from "@material-ui/core";
import { makeStyles, createMuiTheme, MuiThemeProvider} from "@material-ui/core/styles";

// Material Icons
import { AssessmentTwoTone } from "@material-ui/icons";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

//cookies
import {get_cookies} from "../../components/Cookies/Cookies";
import numeral from "numeral";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	// paper: {
	// 	backgroundColor: theme.palette.background.paper,
	// 	border: "2px solid #000",
	// 	boxShadow: theme.shadows[5],
	// 	padding: theme.spacing(2, 4, 3),
	// },
}));


// const getMuiTheme = () => createMuiTheme({
// 	overrides: {
// 	  MUIDataTableHeadCell: {
// 		root: {
// 		  '&:nth-child(1)': {
// 				width: 100
// 			  },	
// 		  '&:nth-child(2)': {
// 			width: 100
// 		  },
// 		  '&:nth-child(3)': {
// 			width: 380
// 		  },
// 		  '&:nth-child(4)': {
// 			width: 230
// 		  },
// 		  '&:nth-child(5)': {
// 			width: 180,
// 		  },
// 		  '&:nth-child(6)': {
// 			width: 250
// 		  },
// 		}
// 	  }
// 	}
//   });


const CheckTransactionHistory = () => {
	const [posts, setPosts] = useState([]);
	const [dataLoaded, setDataLoaded] = useState(false);
	const [open, setOpen] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const [downloadFlag, setDownloadFlag] = useState(false);
	const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: new Date(),
	});
	const classes = useStyles();

	const [useridNo, setuseridNo] = useState(get_cookies('branchidno'));

	// Data Fetching
	useEffect(() => {
		data();
	}, []);

	useEffect(() => {
		if(posts.length > 0){
			setDownloadFlag(true);
		}else{
			setDownloadFlag(false);
		}
	}, [posts]);
	//search button
	const dataFilter = async () => {
		setDataLoaded(false);
        await axios.get(
			process.env.REACT_APP_API_URL+'get_checks_trans_history', {
            params:{
                date_from: format(dateRange.startDate, "yyyy-MM-dd"), //format(dateRange.startDate, "yyyy/MM/dd/")
                date_to: format(dateRange.endDate, "yyyy-MM-dd"),   //format(dateRange.endDate, "yyyy/MM/dd/")
                jc_user_id_no: useridNo,  
            }
        }).then((res)=>{
			setPosts(res.data.data);
		}).catch((error)=>{
		//console.log(error.message);
		})
		setDataLoaded(true);
    }

	const data = async () => {
		setDataLoaded(true);
	};

	const toggle = () => setOpen(!open);

	const handleModalOpen = () => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen(false);
	};

	const printCheck = async (chkno, branchidno) =>{
		const formData = new FormData();
		formData.append("chkno",chkno);
		formData.append("jc_u_idno", branchidno);
		await axios.post(process.env.REACT_APP_API_URL+'print_check', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
				}
        }).then((res)=>{
			//console.log(res.data.pdf)

			 //window.open("data:application/pdf," + res.data.pdf,"_blank"); 
			 let pdfWindow = window.open("")
				pdfWindow.document.write(
				    "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
				    encodeURI(res.data.pdf) + "'></iframe>"
				)
				dataFilter(); //refresh to apply printed=yes status	

		}).catch((error)=>{
		//console.log(error.message);
		})
	}

	const columns = [
		{
			name: "date",
			label: "Date",
		},
		{
			name: "reference",
			label: "Reference",
		},
		{
			name: "payto",
			label: "Pay To",
		},
		{
			name: "amount",
			label: "Amount",
			options: {
				customBodyRender: (value, tableMeta, updateValue) => {
					return (
							<div style={{textAlign:"right"}}>{numeral(value).format('0,0.00')}</div>
					);
				  }
				}
		},
		{
			name: "status",
			label: "Status",
		},
		{
			name: "printed",
			label: "Printed",
		},
		{
			name: "cleared",
			label: "Cleared",
		},
		{
			name: "allocation",
			label: "Allocation",
		},
		{
			name: "reference",
			label: "Action",
			options: {
				sort:false, 
				filter: false, 
				customBodyRenderLite: (dataIndex) => {
					let chkno =  posts[dataIndex].reference;
					let checkstatus =  posts[dataIndex].status;
					let printed =  posts[dataIndex].printed;
					let cleared =  posts[dataIndex].cleared;
					//return poretno + " " + allocateall;
					if(checkstatus === "Approved" && printed ==="No"){
						return (
							<Grid container spacing={1}>
								<Grid item xs={12} sm={6} md={6} lg={12} xl={12}>
									<NavLink to={"/account/check-view/"+chkno+"/"+useridNo}> {/*Check View*/}
										<Button variant="contained" color="primary">
											View
										</Button>	
									</NavLink> 
								</Grid>
								<Grid item xs={12} sm={6} md={6} lg={12} xl={12}>
									{/* chkno useridNo */}
										<Button variant="contained" color="primary" onClick={()=>{printCheck(chkno,useridNo)}}>  
											Print
										</Button>	
								</Grid>
							</Grid>
						);
					}else if(checkstatus === "Approved" && printed==="Yes"){
						return (
							<Grid container spacing={1}>
								<Grid item xs={12} md={6} lg={12} xl={12}>
									<NavLink to={"/account/check-view-reference/"+chkno+"/"+useridNo}> {/*Check View Reference */}
										<Button variant="contained" color="primary">
											View
										</Button>	
									</NavLink> 
								</Grid>		
									   {cleared==="No"?
									   (
										<Grid item xs={12} d={6} lg={12} xl={12}>
											<NavLink to={"/account/check-clear-view/"+chkno+"/"+useridNo}> {/*Check View Reference */}
										    	<Button variant="contained" color="primary">
										   			Clear
									   			</Button>
											 </NavLink> 
										</Grid>	   
									   ):
									   (
										   <></>
									   )}
							</Grid>
						);	
					}else{
						return (
							<Grid container spacing={1}>
								<Grid item xs={12} lg={6} xl={5}>
									<NavLink to={"/account/check-view/"+chkno+"/"+useridNo}> {/*Check View*/}
										<Button variant="contained" color="primary">
											View
										</Button>	
									</NavLink> 
								</Grid>
							</Grid>
						);	
					}
				},
				download: false //exclude this column in csv export
			}
		},
	];

	const options = {
		filter: true,
		// filterType: "dropdown",
		selectableRows: "none",
		filterType: "multiselect",
		responsive: "standard",
		setFilterChipProps: (colIndex, colName, data) => {
			//console.log(colIndex, colName, data);
			return {
				color: "primary",
				variant: "outlined",
				className: "testClass123",
			};
		},
		download: downloadFlag,  //add this
		print: downloadFlag, //add this
		downloadOptions: {
			filename : 'CheckTransactionHistory.csv' //change filename of csv
		}
		// tableBodyHeight,
	};

    const style = {
		marginBottom: '1rem',
		marginTop:"2.5em",
	};

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<AssessmentTwoTone />
				</div>
				<NavLink to={"/account"}><h4 style={{color:"#339933"}}>Accounts</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<h4>Check Transaction History</h4>
			</div>
			<div className="page-container">
				<div style={style}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                                <TextField
                                    id="outlined-basic"
                                    label="Select Date"
                                    variant="outlined"
                                    onFocus={() => setOpen(true)}
                                    fullWidth={true}
                                    autoComplete="off"
                                    value={`${format(
                                        dateRange.startDate,
                                        "MM/dd/yyyy"
                                    )} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
                                />
                                <DateRangePicker
                                    open={open}
                                    toggle={toggle}
                                    onChange={(range) => dateRangeHandler(range)}
                                /> 
                            </Grid>
                            <Grid item xs={1} lg={1} xl={1}>
                                <Button variant="contained" style ={{marginTop: "23px"}} color="primary"  onClick={() => {dataFilter()}}>Search</Button>
                            </Grid>
                        </Grid>        
                    </div>
				{!dataLoaded ? (
					<Preloader />
				) : (
					// <MuiThemeProvider theme={getMuiTheme()}>
						<MUIDataTable
							title={
								<div>
							
									<div className="table-title">
									Check Transaction History
									</div>
								</div>
							}
							data={posts}
							columns={columns}
							options={options}
						/>
				//   </MuiThemeProvider>
				)}
			</div>
		</div>
	);
};

export default CheckTransactionHistory;
